import React from "react";
import logo from "../ok.png"; // Assuming the logo is in the same directory

export default function Navbar() {
  return (
    <header className="nav">
      <div className="container nav__inner">
        <a href="#home" className="brand">
          <img 
  src="https://thebullstrading.com/wp-content/uploads/2025/08/Brand-Media-Kit-tt-04.png" 
  alt="The Bulls Trading Academy Logo" 
  className="brand__logo" 
/>

          {/* <span className="brand__icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M3 16c0-.761 2.239-5 5-5h2l2-3h3l3 3h3v2h-3l-3-3h-1l-2 3H8a3 3 0 0 0-3 3H3z"></path>
            </svg>
          </span> */}
          {/* <div className="brand__text">
            <span className="brand__title">The Bulls Trading Academy</span>
            <span className="brand__subtitle">CMT Prep</span>
          </div> */}
        </a>
        <nav className="nav__links">
          <a href="#levels">The Program</a>
          <a href="#faq">FAQ</a>
          <a href="#contact" className="btn btn--outline btn--sm">Join Call</a>
        </nav>
      </div>
    </header>
  );
}
